import { Button, styled } from '@cherre-frontend/ui';

export const ConnectorRevisionReleaseBannerContainer = styled('div')`
  border-radius: 10px;
  padding-top: 6px;
  padding: 10px;
  background-color: #df24671a;
  color: #212121;
  font-size: 14px;
  letter-spacing: 1%;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const MessageContainer = styled('p')`
  margin: 0;
`;

export const MessageContent = styled('span')`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 14px;
  line-height: 17.5px;
  letter-spacing: 1%;
  font-weight: 500;
  margin: 0px;
`;

export const StyledButton = styled(Button)`
  color: #df2467;
`;
